document.addEventListener('DOMContentLoaded', function() {

   // 期限切れのカート商品をチェックして削除する関数
    async function checkExpiredCartItems() {
      try {
        // ローカルストレージからデータを取得
        const savedData = localStorage.getItem('verifiedProductData');
        if (!savedData) return;
        
        const data = JSON.parse(savedData);
        const currentTime = Date.now();
        
        // 24時間経過したかチェック
        if (currentTime > data.expiryTime) {
          // console.log('検証データが期限切れになりました。カートから商品を削除します...');
          
          // カートの内容を取得
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          // 該当商品がカートにあるかチェック
          const itemToRemove = cart.items.find(item => 
            item.variant_id === data.variantId && 
            item.properties && 
            item.properties['ユーザーID'] === data.userId && 
            item.properties['シリアルナンバー'] === data.serialCode
          );
          
          if (itemToRemove) {
            // 該当商品をカートから削除
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: itemToRemove.key,
                quantity: 0
              })
            });
            
            // console.log('期限切れの商品をカートから削除しました');
          }
          
          // ローカルストレージからデータを削除
          localStorage.removeItem('verifiedProductData');
        } else {
          // まだ期限内の場合、残り時間をログ表示
          const remainingTimeHours = Math.round((data.expiryTime - currentTime) / (60 * 60 * 1000));
          // console.log(`検証データの有効期限まであと約${remainingTimeHours}時間です`);
        }
      } catch (error) {
        console.error('カートの期限切れチェック中にエラーが発生しました:', error);
      }
    }
      // 期限切れのカート商品をチェックして削除
    checkExpiredCartItems();
    // 定期的にカートをチェックする（オプション：5分ごとなど）
    setInterval(checkExpiredCartItems,5000);



});



// 時間変更ロジック

// (function() {
//   function formatPrice(price) {
//     return new Intl.NumberFormat('ja-JP').format(price);
//   }
  
//   function parseDateTime(dateTimeStr) {
//     if (!dateTimeStr) return null;
//     const [date, time] = dateTimeStr.split('-');
//     const [year, month, day] = date.split('-');
//     const [hour, minute] = time.split(':');
//     return new Date(year, month - 1, day, hour, minute);
//   }
  
//   function updatePriceDisplay(productId) {
//     const data = window.discountData[productId];
//     if (!data || !data.hasDiscount) return;
    
//     const container = document.querySelector(`[data-product-id="${productId}"]`);
//     if (!container) return;
    
//     const now = new Date();
//     const startTime = parseDateTime(data.startTime);
//     const endTime = parseDateTime(data.endTime);
    
//     let showDiscount = false;
    
//     // 割引表示条件の判定
//     if (data.hasDiscount) {
//       if (!startTime && !endTime) {
//         // 開始・終了時間共に未設定 → 常に割引表示
//         showDiscount = true;
//       } else if (!startTime && endTime) {
//         // 開始時間未設定、終了時間あり → 終了時間まで表示
//         showDiscount = now <= endTime;
//       } else if (startTime && !endTime) {
//         // 開始時間あり、終了時間未設定 → 開始時間から常に表示
//         showDiscount = now >= startTime;
//       } else if (startTime && endTime) {
//         // 両方設定 → 期間内のみ表示
//         showDiscount = now >= startTime && now <= endTime;
//       }
//     }
    
//     // 価格表示の更新
//     if (showDiscount) {
//       container.innerHTML = `
//         <p class="p-radio__after-price line-price" data-price-type="discount">
//           <span>¥</span>${formatPrice(data.discountPrice)}
//         </p>
//         <p class="p-radio__after-price sale-price" data-price-type="regular">
//           <span class="dli-caret-right pc-hide"></span>
//           <span>¥</span>${formatPrice(data.regularPrice)}
//         </p>
//       `;
//     } else {
//       container.innerHTML = `
//         <p class="p-radio__after-price" data-price-type="regular-only">
//           <span>¥</span>${formatPrice(data.regularPrice)}
//         </p>
//       `;
//     }
//   }
  
//   // 初期化とタイマー設定
//   function initPriceControl() {
//     Object.keys(window.discountData).forEach(productId => {
//       updatePriceDisplay(productId);
//     });
    
//     // 1分ごとに更新
//     setInterval(() => {
//       Object.keys(window.discountData).forEach(productId => {
//         updatePriceDisplay(productId);
//       });
//     }, 60000);
//   }
  
//   // DOMが読み込まれた後に実行
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initPriceControl);
//   } else {
//     initPriceControl();
//   }
// })();